<template>
	<div class="flex xl:hidden mr-4"
         v-cloak
    >
        <button class="relative w-6 h-6"
                @click="show = ! show"
        >
            <svg class="w-6 h-6 transition-opacity duration-150 absolute top-0 left-0"
                 :class="{ 'opacity-100': ! show, 'opacity-0': show }"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
            >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>

            <svg class="w-6 h-6 transition-opacity duration-150 absolute top-0 left-0"
                 :class="{ 'opacity-100': show, 'opacity-0': ! show }"
                 fill="none"
                 stroke="currentColor"
                 viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg"
            >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>

        <div class="absolute top-full left-0 w-screen h-screen-less-menu py-4 px-4 lg:px-12 bg-white transition transition-transform duration-300 transform"
             :class="{ '-translate-x-full': ! show, 'translate-x-0': show }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
	export default {
        data() {
            return {
                show: false,
            }
        }
	}
</script>
